import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/navlogo.png'


const _hoisted_1 = {
  class: "navbar navbar-vertical navbar-light fixed-start navbar-expand-md d-md-none",
  id: "sidebar"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "avatar avatar-sm" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "fa-solid fa-user-circle text-muted",
  style: {"font-size":"40px"}
}
const _hoisted_6 = {
  class: "navbar-collapse collapse",
  id: "sidebarCollapse"
}
const _hoisted_7 = { class: "navbar-nav" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "nav-link text-paragraph" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-link text-paragraph" }

import { storeToRefs } from "pinia";
import { useSessionStore } from "@/store/useSessionStore";
import paths from "@/router/paths";
import { getNavLinks, isNavLinkActive } from "./navLinks";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const route = useRoute();
const { session } = storeToRefs(useSessionStore());

const links = getNavLinks(paths);


return (_ctx: any,_cache: any) => {
  const _component_VersionComponent = _resolveComponent("VersionComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#sidebarCollapse",
        "aria-controls": "sidebarCollapse",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createVNode(_component_router_link, {
        class: "navbar-brand text-start d-flex align-items-center",
        to: _unref(paths).home
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            src: _imports_0,
            class: "navbar-brand-img rounded me-2",
            alt: ""
          }, null, -1)),
          _createVNode(_component_VersionComponent)
        ]),
        _: 1
      }, 8, ["to"]),
      (_unref(session))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _unref(paths).more,
            class: "navbar-user d-md-none",
            id: "sidebar-profile"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_unref(session)?.formatted_image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(session)?.formatted_image,
                      class: "avatar-img rounded-circle",
                      alt: ""
                    }, null, 8, _hoisted_4))
                  : (_openBlock(), _createElementBlock("i", _hoisted_5))
              ])
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          (!_unref(session))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                "active-class": "router-link-active",
                to: _unref(paths).login
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("li", { class: "nav-item" }, [
                    _createElementVNode("a", { class: "nav-link text-paragraph" }, "Entrar")
                  ], -1)
                ]))]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(links), (link) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: link.title
                }, [
                  (link.navigate)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: "nav-item cursor-pointer",
                        onClick: ($event: any) => (link.navigate())
                      }, [
                        _createElementVNode("a", _hoisted_9, _toDisplayString(link.title), 1)
                      ], 8, _hoisted_8))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        "active-class": "nav-route-matched",
                        "exact-active-class": "nav-route-exact",
                        class: _normalizeClass({ 'router-link-active': _unref(isNavLinkActive)(_unref(route).path, link.to) }),
                        to: link.to
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("li", _hoisted_10, [
                            _createElementVNode("a", _hoisted_11, _toDisplayString(link.title), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class", "to"]))
                ], 64))
              }), 128))
        ])
      ])
    ])
  ]))
}
}

})